import SegmentedButton from "@/components/SegmentedButton";
import type { CareerServicesDashboardWindow } from "../queries";
import { DASHBOARD_TIMEFRAME_OPTIONS, isCareerServicesDashboardWindow } from "../_utils/dashboardTimeframe";

type DashboardTimeframeToggleProps = {
  value: CareerServicesDashboardWindow;
  onChange: (value: CareerServicesDashboardWindow) => void;
  testId: string;
};

export default function DashboardTimeframeToggle({ value, onChange, testId }: DashboardTimeframeToggleProps) {
  return (
    <div className="flex flex-col items-start gap-1" data-testid={testId}>
      <span className="text-label-medium text-sys-brand-on-surface-variant">Timeframe</span>
      <SegmentedButton
        ariaLabel="Dashboard timeframe"
        options={DASHBOARD_TIMEFRAME_OPTIONS}
        value={value}
        maxButtonWidth={64}
        onChange={(nextValue) => {
          if (isCareerServicesDashboardWindow(nextValue)) {
            onChange(nextValue);
          }
        }}
      />
    </div>
  );
}
